import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color: string;
    radius?: number;
}

export const CustomDot = ({ color, radius = 4 }: Props): JSX.Element => {
    const size = radius * 2;
    return (
        <SvgIcon style={{ width: size, height: size }} viewBox={`0 0 ${size} ${size}`}>
            <svg
                xmlns={'http://www.w3.org/2000/svg'}
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                fill={'none'}
            >
                <circle cx={radius} cy={radius} r={radius} fill={color} />
            </svg>
        </SvgIcon>
    );
};
